import type { SxProps, Theme } from '@mui/material/styles';

type TransferDetailStyleMap = {
    loadingContainer: SxProps<Theme>
    root: SxProps<Theme>
    header: SxProps<Theme>
    headerLeft: SxProps<Theme>
    headerActions: SxProps<Theme>
    card: SxProps<Theme>
    cardHeader: SxProps<Theme>
    ownersGrid: SxProps<Theme>
    dialogActions: SxProps<Theme>
    approveChangesBox: SxProps<Theme>
};

type InfoRowStyleMap = {
    root: SxProps<Theme>
};

export const transferDetailStyles: TransferDetailStyleMap = {
    loadingContainer: { display: 'flex', justifyContent: 'center', mt: 8 },
    root: { display: 'flex', flexDirection: 'column', gap: 3 },
    header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 2 },
    headerLeft: { display: 'flex', alignItems: 'center', gap: 2 },
    headerActions: { display: 'flex', gap: 1.5 },
    card: { border: '1px solid', borderColor: 'divider', borderRadius: 2, overflow: 'hidden' },
    cardHeader: { px: 3, py: 2, borderBottom: '1px solid', borderColor: 'divider' },
    ownersGrid: { display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' }, gap: 3 },
    dialogActions: { px: 3, pb: 2 },
    approveChangesBox: { mt: 1.5, p: 2, border: '1px solid', borderColor: 'divider', borderRadius: 1, display: 'flex', flexDirection: 'column', gap: 1 },
};

export const infoRowStyles: InfoRowStyleMap = {
    root: { px: 3, py: 2, display: 'grid', gridTemplateColumns: '200px 1fr', gap: 2, alignItems: 'start' },
};
